"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundedCorners = exports.borderRadius = exports.border = void 0;

var _styledComponents = require("styled-components");

var _color = require("./color");

var _units = require("./units");

const borderRadius = props => (0, _units.rem)(props.theme.borderRadius);

exports.borderRadius = borderRadius;
const roundedCorners = (0, _styledComponents.css)(["border-radius:", ";"], borderRadius);
exports.roundedCorners = roundedCorners;

const border = props => "1px solid ".concat((0, _color.borderColor)(props));

exports.border = border;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJib3JkZXJSYWRpdXMiLCJwcm9wcyIsInJlbSIsInRoZW1lIiwicm91bmRlZENvcm5lcnMiLCJjc3MiLCJib3JkZXIiLCJib3JkZXJDb2xvciJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS91dGlsaXR5L2JvcmRlci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdzdHlsZWQtY29tcG9uZW50cydcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFByb3BzIH0gZnJvbSAnLi4vdGhlbWUudHlwZXMnXG5pbXBvcnQgeyBib3JkZXJDb2xvciB9IGZyb20gJy4vY29sb3InXG5pbXBvcnQgeyByZW0gfSBmcm9tICcuL3VuaXRzJ1xuXG5leHBvcnQgY29uc3QgYm9yZGVyUmFkaXVzID0gKHByb3BzOiBUaGVtZWRDb21wb25lbnRQcm9wcykgPT4gcmVtKHByb3BzLnRoZW1lLmJvcmRlclJhZGl1cylcblxuZXhwb3J0IGNvbnN0IHJvdW5kZWRDb3JuZXJzID0gY3NzYFxuICBib3JkZXItcmFkaXVzOiAke2JvcmRlclJhZGl1c307XG5gXG5cbmV4cG9ydCBjb25zdCBib3JkZXIgPSAocHJvcHM6IFRoZW1lZENvbXBvbmVudFByb3BzKSA9PiBgMXB4IHNvbGlkICR7Ym9yZGVyQ29sb3IocHJvcHMpfWBcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOztBQUNBOztBQUVPLE1BQU1BLFlBQVksR0FBSUMsS0FBRCxJQUFpQyxJQUFBQyxVQUFBLEVBQUlELEtBQUssQ0FBQ0UsS0FBTixDQUFZSCxZQUFoQixDQUF0RDs7O0FBRUEsTUFBTUksY0FBYyxPQUFHQyxxQkFBSCwyQkFDUkwsWUFEUSxDQUFwQjs7O0FBSUEsTUFBTU0sTUFBTSxHQUFJTCxLQUFELHdCQUE4QyxJQUFBTSxrQkFBQSxFQUFZTixLQUFaLENBQTlDLENBQWYifQ==